import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VisitaGetEnderecoPipe} from './visita-get-cidade.pipe';
import {CpfCnpjPipe} from './cpfcnpj.pipe';
import {ChatPipe} from './chat.pipe';
import {FileSizePipe} from './file-size.pipe';
import {NoWhiteSpacesPipe} from './no-white-spaces.pipe';
import { TruncatePipe } from './truncate.pipe';

@NgModule({
  declarations: [VisitaGetEnderecoPipe, CpfCnpjPipe, ChatPipe, FileSizePipe, NoWhiteSpacesPipe, TruncatePipe],
  exports: [
    VisitaGetEnderecoPipe, CpfCnpjPipe, ChatPipe, FileSizePipe, NoWhiteSpacesPipe, TruncatePipe
  ],
  imports: [
    CommonModule,
  ],
})
export class PipesModule {
}
